import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
import { ComponentPortal } from '@angular/cdk/portal';
import { SpinnerOverlayComponent } from '../shared/spinner-overlay/spinner-overlay.component';

@Injectable({
    providedIn: 'root'
})
export class SpinnerService {

    private overlayRef: OverlayRef = null;

    constructor(private overlay: Overlay) { }

    public show() {
        if (this.overlayRef && this.overlayRef.hasAttached()) {
            return;
        }

        // Returns an OverlayRef (which is a PortalHost)
        if (!this.overlayRef) {
            this.overlayRef = this.overlay.create();
        }

        // Create ComponentPortal that can be attached to a PortalHost
        const spinnerOverlayPortal = new ComponentPortal(SpinnerOverlayComponent);
        this.overlayRef.attach(spinnerOverlayPortal); // Attach ComponentPortal to PortalHost
    }

    public hide() {
        if (this.overlayRef && this.overlayRef.hasAttached()) {
            this.overlayRef.detach();
        }
    }
}
